import { NativeDateAdapter } from '@angular/material/core';
import moment from 'moment';

// Day-first dotted format used consistently across the whole app: every
// `general.dateFormat` translation (DD.MM.YYYY / TT.MM.JJJJ / ...) and every
// manual `moment(value, 'DD.MM.YYYY', true)` parse handler in the components.
// We deliberately do NOT parse via the active moment locale here: moment's
// locale data is not bundled in this build, so `moment.localeData(...)` would
// silently fall back to en (MM/DD) and reintroduce the day/month swap.
const TX_DATE_FORMATS = ['DD.MM.YYYY', 'D.M.YYYY', 'DD.MM.YY', 'DDMMYYYY'];

export class TxDateAdapter extends NativeDateAdapter {
	getFirstDayOfWeek(): number {
		return 1;
	}

	// Parse keyboard input as DD.MM.YYYY instead of NativeDateAdapter's
	// Date.parse(), which reads dotted "12.06.2026" as en-US MM.DD and swaps
	// day/month (-> 06.12.2026). Strict first, then a lenient fallback so a
	// fully typed date is never silently dropped.
	parse(value: any): Date | null {
		if (value === null || value === undefined || value === '') {
			return null;
		}
		if (typeof value === 'number') {
			return new Date(value);
		}
		const raw = String(value).trim();
		const strict = moment(raw, TX_DATE_FORMATS, true);
		if (strict.isValid()) {
			return strict.toDate();
		}
		const lenient = moment(raw, TX_DATE_FORMATS, false);
		return lenient.isValid() ? lenient.toDate() : null;
	}

	// Display short dates zero-padded as DD.MM.YYYY so typed input round-trips
	// consistently with the parse format above. Calendar month/year headers and
	// other display formats keep the native (Intl) rendering.
	format(date: Date, displayFormat: any): string {
		if (date === null || date === undefined || !this.isValid(date)) {
			return super.format(date, displayFormat);
		}
		const isShortDate =
			displayFormat &&
			typeof displayFormat === 'object' &&
			displayFormat.day &&
			displayFormat.month &&
			displayFormat.year;
		if (!isShortDate) {
			return super.format(date, displayFormat);
		}
		return moment(date).format('DD.MM.YYYY');
	}
}
